import { render } from "./PtAutoComplete.vue?vue&type=template&id=ae63a938&ts=true"
import script from "./PtAutoComplete.vue?vue&type=script&lang=ts"
export * from "./PtAutoComplete.vue?vue&type=script&lang=ts"

import "./PtAutoComplete.vue?vue&type=style&index=0&id=ae63a938&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__